import type * as lazyIndex from './lazyIndex';
import type { CopilotCommandCenterProps } from './components/CopilotCommandCenter';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import { CopilotCommandCenterPlaceholder } from './components/CopilotCommandCenterPlaceholder';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCommandCenter" */ './lazyIndex'),
    { name: 'CopilotCommandCenter' }
);

export const CopilotCommandCenter: LazyComponent<CopilotCommandCenterProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCommandCenter, CopilotCommandCenterPlaceholder);
